import Model from './Model';
import CarUse from './CarUse';
import ServiceTime from './ServiceTime';
import Expense from './Expense';
import DailyAllowance from './DailyAllowance';

export default class Report extends Model {
  resource() {
    return 'reports';
  }

  carUses() {
    return this.hasMany(CarUse);
  }

  serviceTimes() {
    return this.hasMany(ServiceTime);
  }

  expenses() {
    return this.hasMany(Expense);
  }

  dailyAllowances() {
    return this.hasMany(DailyAllowance);
  }
}
